// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3b9SP","title":"Images45_title__w12qQ","images":"Images45_images__2HGlH"};